import React from 'react'
import { Helmet } from 'react-helmet'

import { isUnderTest } from '../Helpers/isUnderTest'
import { useHasConsent } from '../Hooks/useHasConsent/useHasConsent'

export function Demandbase() {
  const hasConsent = useHasConsent(['thirdparty'])
  if (isUnderTest()) return
  if (!hasConsent) {
    return null
  }

  return (
    <Helmet>
      <script type={'text/javascript'}>
        {`(function(d,b,a,s,e){ var t = b.createElement(a),
  fs = b.getElementsByTagName(a)[0]; t.async=1; t.id=e; t.src=s;
  fs.parentNode.insertBefore(t, fs); })
(window,document,'script','https://tag.demandbase.com/28c71589ed11a164.min.js','demandbase_js_lib');`}
      </script>
    </Helmet>
  )
}
